import { useEffect, useMemo, useState } from "react";
import API from "../../api/api";

import useIsMobile from "../../hooks/useIsMobile";
import { useNavigate } from "react-router-dom";


export default function AvailableTours() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  

 const canSelfAssign = true;

    const uniqueTours = useMemo(() => {

    return [...new Set(
        tours.map(t => t.title)
    )].sort();

}, [tours]);

  /* ================= FILTER STATE ================= */
  const FILTER_STORAGE_KEY = "coordinator_available_tours_filters";

const defaultFilters = {
    date: "30",
    specificDate: "",
    tour: [],
    language: "all",
    bookings: "all"
};

const [filters, setFilters] = useState(() => {
    try {
        const saved = localStorage.getItem(FILTER_STORAGE_KEY);

        if (!saved) {
            return defaultFilters;
        }

       const parsed = JSON.parse(saved);

return {
    ...defaultFilters,
    ...parsed,
    tour: Array.isArray(parsed.tour)
        ? parsed.tour
        : parsed.tour === "all" || !parsed.tour
            ? []
            : [parsed.tour]
};

    } catch (err) {
        console.error(
            "Unable to load saved coordinator filters:",
            err
        );

        return defaultFilters;
    }
});

useEffect(() => {
    localStorage.setItem(
        FILTER_STORAGE_KEY,
        JSON.stringify(filters)
    );
}, [filters]);

const [showFilters, setShowFilters] = useState(false);
const [tourDropdownOpen, setTourDropdownOpen] = useState(false);

const toggleTour = (tourName) => {
    setFilters(prev => {
        const current = Array.isArray(prev.tour)
            ? prev.tour
            : [];

        const exists = current.includes(tourName);

        return {
            ...prev,
            tour: exists
                ? current.filter(name => name !== tourName)
                : [...current, tourName]
        };
    });
};

const clearTourFilter = () => {
    setFilters(prev => ({
        ...prev,
        tour: []
    }));
};

const [assignModal, setAssignModal] = useState({
    open: false,
    tourId: null,
    status: "confirm"
});



  /* ================= DATE FORMATTER ================= */
  const formatDateTime = (dateString) => {
    if (!dateString) return "No date";

    const date = new Date(dateString);

    const weekday = date.toLocaleDateString("en-GB", {
      weekday: "long"
    });

    const day = String(date.getDate()).padStart(2, "0");

    const month = date.toLocaleDateString("en-GB", {
      month: "long"
    });

    const year = date.getFullYear();

    const time = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });

    return `${weekday}, ${day} ${month} ${year} • ${time}`;
  };

  /* ================= LOAD ================= */
  const load = async () => {
    try {
      setLoading(true);
      const res = await API.get("/coordinator/available");
      setTours(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("load available tours error:", err);
      setTours([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  /* ================= ASSIGN ================= */
  const assign = async (id) => {
  try {
    await API.post(`/coordinator/assign/${id}`);

    // Remove from Available Tours
    setTours(prev => prev.filter(t => t.id !== id));

    // Show success popup
    setAssignModal({
      open: true,
      tourId: id,
      status: "success"
    });

    // Refresh list
    load();

  } catch (err) {
    console.error("assign error:", err);

    setAssignModal({
      open: true,
      tourId: id,
      status: "not-assigned"
    });
  }
};

const openAssignModal = (id) => {

    setAssignModal({
        open: true,
        tourId: id,
        status: "confirm"
    });

};

const closeAssignModal = () => {

    setAssignModal({
        open: false,
        tourId: null,
        status: "confirm"
    });

};

  /* ================= FILTERED DATA ================= */

const languages = useMemo(() => {

    return [...new Set(
        tours
            .map(t => t.languages)
            .filter(Boolean)
    )].sort();

}, [tours]);

const filteredTours = useMemo(() => {

    return tours.filter((t) => {

        const matchBookings = (() => {

            if (filters.bookings === "all") {
                return true;
            }

            if (filters.bookings === "booked") {
                return (t.booked ?? 0) > 0;
            }

            if (filters.bookings === "empty") {
                return (t.booked ?? 0) === 0;
            }

            return true;

        })();

       

        const selectedTours = Array.isArray(filters.tour)
    ? filters.tour
    : [];

const matchTour =
    selectedTours.length === 0
    || selectedTours.includes(t.title);

        const matchLanguage =
            filters.language === "all"
            || (t.languages || "")
                .split(",")
                .map(l => l.trim())
                .includes(filters.language);

        const matchDate = (() => {

            if (!t.start_datetime) return false;

            const tourDate = new Date(t.start_datetime);
            const now = new Date();

            /* Specific date overrides all other date filters */
            if (filters.specificDate) {

                return (
                    tourDate.toISOString().slice(0, 10) ===
                    filters.specificDate
                );

            }

            if (filters.date === "all") {
                return true;
            }

            if (filters.date === "today") {
                return (
                    tourDate.toDateString() ===
                    now.toDateString()
                );
            }

            if (filters.date === "7") {

                const end = new Date(now);
                end.setDate(end.getDate() + 7);

                return tourDate >= now && tourDate <= end;
            }

            if (filters.date === "30") {

                const end = new Date(now);
                end.setDate(end.getDate() + 30);

                return tourDate >= now && tourDate <= end;
            }

            if (filters.date === "90") {

                const end = new Date(now);
                end.setDate(end.getDate() + 90);

                return tourDate >= now && tourDate <= end;
            }

            return true;

        })();

        return (
            matchDate &&
            matchTour &&
            matchLanguage &&
            matchBookings
        );

    });

}, [tours, filters]);

  return (
    <div style={page}>

      {/* HEADER */}
      {
isMobile ?

<div style={mobileHeader}>

    <h2 style={mobileTitle}>
        Available Tours
    </h2>

</div>

:

<div style={header}>

    <h2 style={title}>
        Available Tours
    </h2>

    <p style={subtitle}>
        Browse and assign coordinator tours instantly
    </p>

</div>

}

      

     {/* ================= FILTERS ================= */}

{
isMobile ?

<>

<div style={searchBar}>



    <button

        onClick={()=>

            setShowFilters(
                !showFilters
            )

        }

        style={filterButton}

    >

        {showFilters ? "✖" : "⚙️"}

    </button>

</div>

{

showFilters &&

<div style={filterPanel}>

    <select
        value={filters.bookings}
        onChange={(e)=>

            setFilters(p=>({

                ...p,

                bookings:e.target.value

            }))

        }
        style={select}
    >

        <option value="all">
            Booking status
        </option>

        <option value="booked">
            Booked Tours
        </option>

        <option value="empty">
            Empty Tours
        </option>

    </select>

    <input

        type="date"

        value={filters.specificDate}

        onChange={(e)=>

            setFilters(p=>({

                ...p,

                specificDate:e.target.value

            }))

        }

        style={input}

    />

    <select

        value={filters.date}

        onChange={(e)=>

            setFilters(p=>({

                ...p,

                date:e.target.value

            }))

        }

        style={select}

    >

        <option value="today">
            Today
        </option>

        <option value="7">
            Next 7 Days
        </option>

        <option value="30">
            Next 30 Days
        </option>

        <option value="90">
            Next 3 Months
        </option>

    </select>

    <select

        value={filters.language}

        onChange={(e)=>

            setFilters(p=>({

                ...p,

                language:e.target.value

            }))

        }

        style={select}

    >

        <option value="all">
            All Languages
        </option>

        {

        languages.map(lang=>(

            <option
                key={lang}
                value={lang}
            >

                {lang}

            </option>

        ))

        }

    </select>

    <div style={tourFilterWrapper}>

    <button
        type="button"
        onClick={() =>
            setTourDropdownOpen(prev => !prev)
        }
        style={tourFilterButton}
    >
        <span>
            {filters.tour.length === 0
                ? "All Tours"
                : `${filters.tour.length} tour${filters.tour.length > 1 ? "s" : ""} selected`}
        </span>

        <span>
            ▾
        </span>
    </button>

    {tourDropdownOpen && (
        <div style={tourDropdown}>

            <button
                type="button"
                onClick={clearTourFilter}
                style={tourSelectAll}
            >
                {filters.tour.length === 0 ? "✓ " : ""}
                All Tours
            </button>

            {uniqueTours.map(name => {

                const checked =
                    filters.tour.includes(name);

                return (
                    <label
                        key={name}
                        style={tourOption}
                    >

                        <input
                            type="checkbox"
                            checked={checked}
                            onChange={() =>
                                toggleTour(name)
                            }
                        />

                        <span>
                            {name}
                        </span>

                    </label>
                );

            })}

        </div>
    )}

</div>

    <button
        onClick={load}
        style={refreshBtn}
    >
        Refresh
    </button>

</div>

}

</>

:

<div style={filterBar}>



    <select
        value={filters.bookings}
        onChange={(e)=>

            setFilters(p=>({

                ...p,

                bookings:e.target.value

            }))

        }
        style={{
    ...select,
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis"
}}
    >

        <option value="all">
            Booking status
        </option>

        <option value="booked">
            Booked Tours
        </option>

        <option value="empty">
            Empty Tours
        </option>

    </select>

    <input
        type="date"
        value={filters.specificDate}
        onChange={(e)=>

            setFilters(p=>({

                ...p,

                specificDate:e.target.value

            }))

        }
        style={input}
    />

    <select
        value={filters.date}
        onChange={(e)=>

            setFilters(p=>({

                ...p,

                date:e.target.value

            }))

        }
        style={select}
    >

        <option value="today">
            Today
        </option>

        <option value="7">
            Next 7 Days
        </option>

        <option value="30">
            Next 30 Days
        </option>

        <option value="90">
            Next 3 Months
        </option>

    </select>

    <select
        value={filters.language}
        onChange={(e)=>

            setFilters(p=>({

                ...p,

                language:e.target.value

            }))

        }
        style={select}
    >

        <option value="all">
            All Languages
        </option>

        {

        languages.map(lang=>(

            <option
                key={lang}
                value={lang}
            >

                {lang}

            </option>

        ))

        }

    </select>

    <div style={tourFilterWrapper}>

    <button
        type="button"
        onClick={() =>
            setTourDropdownOpen(prev => !prev)
        }
        style={tourFilterButton}
    >
        <span>
            {filters.tour.length === 0
                ? "All Tours"
                : `${filters.tour.length} tour${filters.tour.length > 1 ? "s" : ""} selected`}
        </span>

        <span>
            ▾
        </span>
    </button>

    {tourDropdownOpen && (
        <div style={tourDropdown}>

            <button
                type="button"
                onClick={clearTourFilter}
                style={tourSelectAll}
            >
                {filters.tour.length === 0 ? "✓ " : ""}
                All Tours
            </button>

            {uniqueTours.map(name => {

                const checked =
                    filters.tour.includes(name);

                return (
                    <label
                        key={name}
                        style={tourOption}
                    >

                        <input
                            type="checkbox"
                            checked={checked}
                            onChange={() =>
                                toggleTour(name)
                            }
                        />

                        <span>
                            {name}
                        </span>

                    </label>
                );

            })}

        </div>
    )}

</div>

    <button
        onClick={load}
        style={refreshBtn}
    >
        Refresh
    </button>

</div>

}

{/* ================= LOADING ================= */}
    
      {loading && (
        <div style={loadingBox}>
          Loading available tours...
        </div>
      )}

      {/* EMPTY */}
      {!loading && filteredTours.length === 0 && (
        <div style={emptyBox}>
          No tours match your filters
        </div>
      )}

      {/* GRID */}
      <div style={grid(isMobile)}>
        {filteredTours.map((t) => {

          const fillPercent =
            t.capacity && t.booked
              ? Math.round((t.booked / t.capacity) * 100)
              : 0;
          return (
            <div
    key={t.id}
    style={card(isMobile)}
    onClick={() => navigate(`/coordinator/tour/${t.id}`)}
>

              {/* HEADER */}
              <div style={cardHeader}>
                <h3 style={tourTitle(isMobile)}>{t.title}</h3>

                <span style={badge}>
                  {fillPercent >= 100 ? "Full" : "Available"}
                </span>
              </div>

              {/* DATE (NEW FORMAT) */}
              <div
                    style={{
                        ...infoRow(isMobile),
                        fontSize: isMobile ? 16 : 14,
                        fontWeight: 1000
                    }}
                    >
                    📅 {formatDateTime(t.start_datetime)}
                    </div>

              {/* CAPACITY */}
              <div style={infoRow(isMobile)}>
                👥 {t.booked ?? 0} / {t.capacity ?? "-"}
              </div>

              <div style={infoRow(isMobile)}>
    🗣️ {t.languages || "English"}
</div>

              {/* PROGRESS BAR */}
              <div style={barBg}>
                <div
                  style={{
                    ...barFill,
                    width: `${fillPercent}%`,
                    background:
                      fillPercent >= 100
                        ? "#ef4444"
                        : fillPercent >= 80
                        ? "#f59e0b"
                        : "#22c55e"
                  }}
                />
              </div>

              <p style={percentText}>
                {fillPercent}% filled
              </p>

              {/* ACTION */}
              {canSelfAssign && (
              <button
    onClick={(e) => {

    e.stopPropagation();

    openAssignModal(t.id);

}}
    style={primaryBtn(isMobile)}
>
                Assign to me
              </button>)}

            </div>
          );
        })}
      </div>

{assignModal.open && (
    <div style={modalOverlay}>

        <div style={modal}>

            {assignModal.status === "confirm" && (
                <>
                    <h3 style={modalTitle}>
                        Assign Tour?
                    </h3>

                    <p style={modalText}>
                        Are you sure you want to assign this tour to yourself?
                    </p>

                    <div style={modalActions}>

                        <button
                            style={secondaryModalBtn}
                            onClick={() =>
                                setAssignModal({
                                    open: true,
                                    tourId: assignModal.tourId,
                                    status: "not-assigned"
                                })
                            }
                        >
                            No
                        </button>

                        <button
                            style={primaryModalBtn}
                            onClick={() =>
                                assign(assignModal.tourId)
                            }
                        >
                            Yes, Assign
                        </button>

                    </div>
                </>
            )}

            {assignModal.status === "success" && (
                <>
                    <h3 style={modalTitle}>
                        Tour Assigned
                    </h3>

                    <p style={modalText}>
                        This tour has been successfully assigned to you as coordinator.
                    </p>

                    <button
                        style={primaryModalBtn}
                        onClick={closeAssignModal}
                    >
                        Close
                    </button>
                </>
            )}

            {assignModal.status === "not-assigned" && (
                <>
                    <h3 style={modalTitle}>
                        Tour Not Assigned
                    </h3>

                    <p style={modalText}>
                        The tour was not assigned to you as coordinator.
                    </p>

                    <button
                        style={secondaryModalBtn}
                        onClick={closeAssignModal}
                    >
                        Close
                    </button>
                </>
            )}

        </div>

    </div>
)}

    </div>
  );
}

/* ================= STYLES ================= */

const page = {
  padding: 24,
  background: "#f8fafc",
  minHeight: "100vh",
  
};

const header = { marginBottom: 16 };

const title = {
  margin: 0,
  fontSize: 22,
  fontWeight: 700,
  color: "#0f172a"
};

const subtitle = {
  marginTop: 4,
  fontSize: 13,
  color: "#64748b"
};

const filterBar = {
  display: "flex",
  gap: 10,
  marginBottom: 18,
  flexWrap: "wrap"
};

const input = {
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #e2e8f0",
  fontSize: 13
};

const select = {
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #e2e8f0",
  fontSize: 13,
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box"
};

const refreshBtn = {
  padding: "10px 14px",
  borderRadius: 10,
  border: "none",
  background: "#0ea5e9",
  color: "white",
  cursor: "pointer"
};

const loadingBox = {
  padding: 20,
  background: "#fff",
  borderRadius: 12,
  border: "1px solid #e2e8f0",
  marginBottom: 16
};

const emptyBox = {
  padding: 30,
  textAlign: "center",
  background: "#fff",
  borderRadius: 12,
  border: "1px solid #e2e8f0",
  color: "#64748b"
};

const grid = (isMobile) => ({

    display: "grid",

    gridTemplateColumns:
        isMobile
            ? "1fr"
            : "repeat(auto-fill, minmax(280px, 1fr))",

    gap: isMobile ? 12 : 14

});

const card = (isMobile) => ({

    background: "white",

    borderRadius: 18,

    padding: isMobile ? 18 : 14,

    border: "1px solid #E2E8F0",

    boxShadow: "0 6px 18px rgba(15,23,42,.06)",

    cursor: "pointer",
transition: ".15s",

WebkitTapHighlightColor: "transparent"

});
const cardHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 8,
  marginBottom: 10
};

const tourTitle = (isMobile) => ({

    margin: 0,

    fontSize: isMobile ? 18 : 15,

    fontWeight: 700,

    color: "#0F172A"

});

const badge = {
  flexShrink: 0,
  alignSelf: "flex-start",
  fontSize: 11,
  padding: "5px 9px",
  borderRadius: 999,
  background: "#dcfce7",
  color: "#166534",
  lineHeight: 1,
  whiteSpace: "nowrap"
};

const infoRow = (isMobile) => ({

    fontSize: isMobile ? 15 : 13,

    color: "#334155",

    marginBottom: 8

});

const barBg = {
  height: 8,
  background: "#e2e8f0",
  borderRadius: 999,
  overflow: "hidden",
  marginTop: 10
};

const barFill = {
  height: "100%",
  borderRadius: 999
};

const percentText = {
  fontSize: 12,
  marginTop: 6,
  color: "#64748b"
};

const primaryBtn = (isMobile) => ({

    marginTop: 14,

    width: "100%",

    padding: isMobile ? 14 : 10,

    borderRadius: 12,

    border: "none",

    background: "#C75028",

    color: "white",

    fontWeight: 700,

    cursor: "pointer",

    fontSize: isMobile ? 16 : 14

});

const mobileHeader = {

    padding: "16px",

    background: "white",

    position: "sticky",

    top: 0,

    zIndex: 10,

    borderBottom: "1px solid #E2E8F0"

};

const mobileTitle = {

    margin: 0,

    fontSize: 22,

    fontWeight: 700

};

const searchBar = {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 15,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box"
};



const filterButton = {

    width: 50,

    borderRadius: 12,

    border: "none",

    background: "#C75028",

    color: "white",

    fontSize: 20

};

const filterPanel = {
    background: "white",
    padding: 15,
    borderRadius: 14,
    marginBottom: 15,
    display: "grid",
    gap: 10,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box"
};

const modalOverlay = {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    zIndex: 1000
};

const modal = {
    width: "100%",
    maxWidth: 420,
    background: "white",
    borderRadius: 18,
    padding: 24,
    boxShadow: "0 20px 50px rgba(15, 23, 42, 0.25)"
};

const modalTitle = {
    margin: "0 0 10px",
    fontSize: 20,
    fontWeight: 700,
    color: "#0F172A"
};

const modalText = {
    margin: "0 0 24px",
    fontSize: 14,
    lineHeight: 1.5,
    color: "#64748B"
};

const modalActions = {
    display: "flex",
    gap: 10,
    justifyContent: "flex-end"
};

const primaryModalBtn = {
    padding: "11px 18px",
    borderRadius: 10,
    border: "none",
    background: "#C75028",
    color: "white",
    fontWeight: 700,
    cursor: "pointer"
};

const secondaryModalBtn = {
    padding: "11px 18px",
    borderRadius: 10,
    border: "1px solid #E2E8F0",
    background: "white",
    color: "#334155",
    fontWeight: 600,
    cursor: "pointer"
};

const tourFilterWrapper = {
    position: "relative",
    minWidth: 220
};

const tourFilterButton = {
    width: "100%",
    minHeight: 42,
    padding: "9px 12px",
    border: "1px solid #d1d5db",
    borderRadius: 8,
    background: "#ffffff",
    color: "#374151",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    cursor: "pointer",
    fontSize: 14,
    textAlign: "left"
};

const tourDropdown = {
    position: "absolute",
    top: "calc(100% + 5px)",
    left: 0,
    right: 0,
    maxHeight: 300,
    overflowY: "auto",
    background: "#ffffff",
    border: "1px solid #d1d5db",
    borderRadius: 8,
    boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
    zIndex: 1000,
    padding: 6
};

const tourSelectAll = {
    width: "100%",
    padding: "10px",
    border: "none",
    borderBottom: "1px solid #e5e7eb",
    background: "#ffffff",
    color: "#374151",
    cursor: "pointer",
    textAlign: "left",
    fontWeight: 700
};

const tourOption = {
    display: "flex",
    alignItems: "center",
    gap: 9,
    padding: "10px",
    cursor: "pointer",
    color: "#374151",
    fontSize: 14
};